import { APPLICATION_MODE } from "./APPLICATION_MODE.js";
const API_TOKENS = (() => {
  switch (process.env.PRISMIC_ENV) {
    case APPLICATION_MODE.Development:
    case APPLICATION_MODE.DevTools:
    case APPLICATION_MODE.MarketingTools:
    case APPLICATION_MODE.Platform:
    case APPLICATION_MODE.Staging:
      return {
        SegmentKey: "Ng5oKJHCGpSWplZ9ymB7Pu7rm0sTDeiG",
        AmplitudeKey: "client-rqVU4xTNaz7F51nBfKRUa0K3qnODiqzh"
      };
    case void 0:
    case "":
    case APPLICATION_MODE.Production:
      return {
        SegmentKey: "cGjidifKefYb6EPaGaqpt8rQXkv5TD6P",
        AmplitudeKey: "client-JuQQWUPimfKWId3WWU6p8xSkTiFqd1qV"
      };
    default:
      throw new Error(`Unknown application mode "${process.env.PRISMIC_ENV}".`);
  }
})();
export {
  API_TOKENS
};
//# sourceMappingURL=API_TOKENS.js.map
